
// export const logout = ( state ) => {
// }

export const setCompanies = (state, companies) => {
    state.companies = companies
}

export const setCompaniesSelectable = (state, companies) => {
    state.companiesSelectable = companies
}

export const setCompaniesPaginated = (state, companiesPaginatedData) => {
    state.companiesPaginatedData = companiesPaginatedData
}

export const setCompanyDetail = (state, company) => {
    state.company = company
}

export const saveNewCompanies = (state, company) => {
    state.companies.unshift(company)
    state.createdData = company;
}

export const saveUpdatedCompany = (state, company) => {
    state.companies.unshift(company)
    state.updatedData = company;
}

export const setDeleteCompany = (state, company) => {
    
    state.companiesPaginatedData.data.filter(x => x.id !== company.id);
    state.deletedData = company
}

export const setCompanyIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setCompanyIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setCompanyIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setCompanyIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}
